/**
 *
 * @module mediaPlayhead
 *
 */

import Services from './../services/entry';

/**
 *
 * @class MediaPlayhead
 * @extends {SDK.Services.Media.MediaPlayhead}
 * @since 2.0.0
 *
 */
export default class MediaPlayhead extends Services.Media.MediaPlayhead {}



// WEBPACK FOOTER //
// ./src/media/mediaPlayhead.js